import { Component, Input } from '@angular/core';
import { CommonService } from '@bst-frontend/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bst-frontend-view-fare-details-modal',
  templateUrl: './view-fare-details-modal.component.html',
  styleUrls: ['./view-fare-details-modal.component.css'],
})
export class ViewFareDetailsModalComponent {
  @Input() orderDetails: any;
  constructor(private activeModal: NgbActiveModal,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    console.log('orderDetails::', this.orderDetails);
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

  getChargeWeight(item: any, productDifferences: any): number {
    return this.commonService.getChargeWeight(item, productDifferences)
  }
}
